<template>
    <div>
        <el-table
                size="mini"
                :data="subscriptionHistory"
                style="width: 100%"
                border fit highlight-current-row
                element-loading-text="Loading"
                v-loading="loader">
            <el-table-column
                    :label="$t('users_tab_subscriptions_history_amount')"
                    width="80px">
                <template slot-scope="scope">
                    {{formatPrice(scope.row.subtotal/100)}}
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('users_tab_subscriptions_history_invoiceNumber')">
                <template slot-scope="scope">
                  <a :href="scope.row.invoice_pdf" target="_blank">{{scope.row.number}}</a>
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('users_tab_subscriptions_history_status')"
                    width="100px">
                <template slot-scope="scope">
                    <div v-if="scope.row.status === 'paid'">
                        <el-tag type="success">{{scope.row.status}}</el-tag>
                    </div>
                    <div v-else>
                        <el-tag>{{scope.row.status}}</el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('users_tab_subscriptions_history_customer')">
                <template slot-scope="scope">
                    {{scope.row.customer_email}}
                </template>
            </el-table-column>
            <el-table-column
                    :label="$t('users_tab_subscriptions_history_created')">
                <template slot-scope="scope">
                    {{moment(scope.row.created, 'X').format('LLLL')}}
                </template>
            </el-table-column>
            <!-- <el-table-column
                    width="100">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="downloadPDF(scope.row)">PDF</el-button>
                </template>
            </el-table-column> -->
        </el-table>
    </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  export default {
    name: "SubscriptionHistory",
    data(){
      return{
        subscriptionHistory: [],
        loader: false,
        moment: moment
      }
    },
    mounted(){

    },
    methods:{
      loadSubscriptionHistory(){
        let loader = this.$loading.show();
        this.loader = true;
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/stripe/getInvoices?companyId=${this.$route.query.companyId}`)
          .then(response => {
            // console.log('---', response.data.invoice.data);
            this.subscriptionHistory = response.data.invoice.data;
            this.loader = false;
            loader.hide()
          })
          .catch(error => {
            console.log(error);
            this.loader = false;
            loader.hide()
          });
      },
      downloadPDF(row){
        let loader = this.$loading.show();
        // window.location.href = row.invoice_pdf + '?mode=attachment';
        window.open(row.invoice_pdf + '?mode=attachment');
        setTimeout(() => {
          loader.hide()
        }, 3000)
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
    }
  }
</script>

<style scoped>

</style>
